import { render } from "./PageMainHeading.vue?vue&type=template&id=5043c7c0"
import script from "./PageMainHeading.vue?vue&type=script&lang=js"
export * from "./PageMainHeading.vue?vue&type=script&lang=js"

import "./PageMainHeading.vue?vue&type=style&index=0&id=5043c7c0&lang=scss"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__